import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input} from '@angular/core';
import {News, TimelineEntry} from "@app/interfaces";
import {AuthService, PreferencesSheetService, ShareService} from "@app/services";
import {EventsService, NewsService} from "@services/api";
import {UserRequiredSheetService} from "@services/user-required-sheet.service";
import {NgIcon} from "@ng-icons/core";

@Component({
  selector: 'app-timeline-entry-action-buttons',
  templateUrl: './timeline-entry-action-buttons.component.html',
  styleUrls: ['./timeline-entry-action-buttons.component.scss'],
  imports: [
    NgIcon
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimelineEntryActionButtonsComponent {

  @Input() entry: TimelineEntry;

  protected authService: AuthService = inject(AuthService);
  protected shareService: ShareService = inject(ShareService);

  private eventsService: EventsService = inject(EventsService);
  private newsService: NewsService = inject(NewsService);
  private userRequiredSheetService: UserRequiredSheetService = inject(UserRequiredSheetService);
  private preferencesSheetService: PreferencesSheetService = inject(PreferencesSheetService);
  private _change: ChangeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
  }

  async openPreferences() {
    if (!this.entry) return;

    await this.preferencesSheetService.openPreferences(this.entry);
  }

  async share() {
    if (!this.entry) return;

    const url = document.location.origin + this.entry.getLink();
    const dialogTitle = this.entry.type === 'news' ? 'News teilen ...' : 'Event teilen ...';
    await this.shareService.share(this.entry.title, url, dialogTitle);
  }

  async toggleLike() {
    if (!this.entry) return;

    if (!this.authService.currentUser()) {
      await this.userRequiredSheetService.open();
      return;
    }

    let entry: Event | News | null = null;

    if (this.entry.type === 'news') {
      entry = await this.newsService.toggleLike(this.entry);
    } else if (this.entry.type === 'event') {
      entry = await this.eventsService.toggleLike(this.entry);
    }

    if (entry) {
      console.log('toggleLike', entry);
      this.entry = new TimelineEntry(entry);
    }

    this._change.markForCheck();
  }

}
